'use strict';

var pullBlock = require('pull-block');

module.exports = function (options) {
  var maxSize = typeof options === 'number' ? options : options.maxChunkSize;
  return pullBlock(maxSize, {
    zeroPadding: false,
    emitEmpty: true
  });
};